export const isNullOrWhiteSpace = str =>
  str === null || str === undefined || str.replace(/\s/g, '').length < 1;

export const removePhoneFormatting = (phone) => {
  if (phone) {
    return phone.replace('(', '').replace(')', '').replace('-', '').replace(' ', '').replace(/\D/, '');
  }
  return '';
};

export const formatPhoneNumber = (phone) => {
  if (phone === null) {
    return '';
  }
  const newPhone = removePhoneFormatting(phone);

  let number = String(newPhone).replace(/\D/g, '');
  number = (({ 7: 1, 10: 1 }[number.length]) ? number.match(/\d{1,3}/g) : 0) || [];
  switch (number.length) {
    case 3: return number[0] + '-' + number[1] + number[2];
    case 4: return '(' + number[0] + ') ' + number[1] + '-' + number[2] + number[3];
    default: return newPhone;
  }
};
